var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live"},[_c('iframe',{attrs:{"width":"100%","height":"100%","src":"http://e.cippe.com.cn/live/index_en","frameborder":"0"}})])}]

export { render, staticRenderFns }